"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _escapeStringRegexp = _interopRequireDefault(require("escape-string-regexp"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var Mark = function Mark(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className"]);
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    className: (0, _classnames["default"])('cloud-ui-search-result-mark', className)
  }, props), children);
};

var DefaultWrapper = function DefaultWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement("a", props, props.children);
};

var safeRegExp = function safeRegExp(phrase, options) {
  try {
    return new RegExp(phrase, options);
  } catch (error) {
    return new RegExp((0, _escapeStringRegexp["default"])(phrase), options);
  }
};

var SearchEntity = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchEntity, _React$Component);

  var _super = _createSuper(SearchEntity);

  function SearchEntity() {
    var _this;

    (0, _classCallCheck2["default"])(this, SearchEntity);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "singlePhraseRegexp", function (name, phrase) {
      var regexp = safeRegExp(phrase.replace(/\s/g, '.*'), 'gi'); // multiple case-insensitive matches may not be identical

      var originalMatches = name.match(regexp);
      var splitName = name.split(regexp);
      var index = 1;
      var markedMatch;

      while (index < splitName.length) {
        markedMatch = _this.phraseMark(originalMatches.shift());
        splitName.splice(index, 0, markedMatch); // inserting matching phrase

        index += 2; //index increased with inserted element
      }

      return splitName;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "combinedRegexp", function (name, phrase) {
      var splitName = [];
      var partedName = name;
      var match, preceding;
      phrase.split(' ').forEach(function (part) {
        if (part) {
          var regexp = safeRegExp(part, 'i');
          match = partedName.match(regexp);

          if (match) {
            preceding = partedName.split(regexp)[0];
            splitName.push(preceding, _this.phraseMark(match[0]));
            partedName = partedName.substr(preceding.length + match[0].length);
          }
        }
      });
      splitName.push(partedName);
      return splitName;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "phraseMark", function (phrase) {
      return /*#__PURE__*/_react["default"].createElement(Mark, null, phrase);
    });
    return _this;
  }

  (0, _createClass2["default"])(SearchEntity, [{
    key: "markedResult",
    value: function markedResult(phrase, name) {
      if (phrase.includes(' ')) {
        return this.combinedRegexp(name, phrase);
      } else {
        return this.singlePhraseRegexp(name, phrase);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          searchPhrase = _this$props.searchPhrase,
          name = _this$props.name,
          _this$props$Wrapper = _this$props.Wrapper,
          Wrapper = _this$props$Wrapper === void 0 ? DefaultWrapper : _this$props$Wrapper,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["searchPhrase", "name", "Wrapper"]);
      var clearPhrase = searchPhrase.replace(/\*/g, '');
      var results = this.markedResult(clearPhrase, name);
      return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({
        className: "cloud-ui-search-result-entity"
      }, rest), results.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: i
        }, item);
      }));
    }
  }]);
  return SearchEntity;
}(_react["default"].Component);

exports["default"] = SearchEntity;
(0, _defineProperty2["default"])(SearchEntity, "propTypes", {
  searchPhrase: _propTypes["default"].string,
  name: _propTypes["default"].string,
  Wrapper: _propTypes["default"].func
});